module.exports = __webpack_public_path__ + "img/nutrition_graph.7710c57f.png";